import React from 'react'
import styles from './TestimonialsSection.module.css'

/* Add as many as you like — cards flow into new rows automatically (3 per row).
   Swap `avatar` with real client photos, or pass a list:
   <TestimonialsSection testimonials={...} /> */
const TESTIMONIALS = [
  {
    category: 'Conferences',
    quote:
      'Collective KatalyX turned our annual conference into a seamless, high-energy experience. Every detail was handled with precision — our leadership team was genuinely impressed.',
    name: 'Rohan Mehta',
    role: 'VP, People & Culture',
    avatar: 'https://i.pravatar.cc/120?img=12',
  },
  {
    category: 'Product Launches',
    quote:
      'The launch was a massive success thanks to their flawless execution and creative staging. Our guests left talking about it for weeks.',
    name: 'Aditi Sharma',
    role: 'Head of Marketing',
    avatar: 'https://i.pravatar.cc/120?img=45',
  },
  {
    category: 'Award Nights',
    quote:
      'From stage production to the final guest moment, the award night ran flawlessly. The team’s calm under pressure is genuinely unmatched.',
    name: 'Vikram Nair',
    role: 'Director, Operations',
    avatar: 'https://i.pravatar.cc/120?img=33',
  },
  {
    category: 'Group Travel',
    quote:
      'They managed our leadership off-site end to end — itinerary, logistics, on-ground delivery. We simply showed up and everything worked.',
    name: 'Priya Deshpande',
    role: 'Chief of Staff',
    avatar: 'https://i.pravatar.cc/120?img=20',
  },
  {
    category: 'Strategic Consulting',
    quote:
      'What sets them apart is strategy. They understood our objectives first, then designed an event that actually delivered on them.',
    name: 'Karan Malhotra',
    role: 'Founder & CEO',
    avatar: 'https://i.pravatar.cc/120?img=53',
  },
  {
    category: 'Employee Engagement',
    quote:
      'Our team engagement program was thoughtful, fun, and genuinely brought people together. Culture you can actually feel.',
    name: 'Sneha Iyer',
    role: 'HR Business Partner',
    avatar: 'https://i.pravatar.cc/120?img=28',
  },
]

const QuoteIcon = () => (
  <svg className={styles.quoteMark} viewBox="0 0 32 24" fill="currentColor" aria-hidden="true">
    <path d="M0 14C0 6.8 4.5 1.5 11 0l1.3 2.7C8.4 4.4 6.4 6.6 6.2 9.4c.4-.1.9-.2 1.4-.2 3.2 0 5.6 2.4 5.6 5.6S10.6 20.6 7.3 20.6 0 18 0 14zm18.7 0c0-7.2 4.5-12.5 11-14l1.3 2.7c-3.9 1.7-5.9 3.9-6.1 6.7.4-.1.9-.2 1.4-.2 3.2 0 5.6 2.4 5.6 5.6s-2.6 5.8-5.9 5.8S18.7 18 18.7 14z" />
  </svg>
)

const TestimonialsSection = ({ testimonials = TESTIMONIALS }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.head}>
          <span className={styles.eyebrow}>Testimonials</span>
          <h2 className={styles.heading}>
            Hear how we’ve made every event truly unforgettable
          </h2>
        </header>

        <div className={styles.grid}>
          {testimonials.map((t, i) => (
            <article key={i} className={styles.card}>
              <span className={styles.badge}>{t.category}</span>

              <QuoteIcon />
              <p className={styles.quote}>{t.quote}</p>

              <div className={styles.footer}>
                {/* <img src={t.avatar} alt={t.name} className={styles.avatar} /> */}
                <div className={styles.person}>
                  <span className={styles.name}>{t.name}</span>
                  {t.role && <span className={styles.role}>{t.role}</span>}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection